import { render, staticRenderFns } from "./AddNewWebHostingPackageModal.vue?vue&type=template&id=dfc25f5a&scoped=true&"
import script from "./AddNewWebHostingPackageModal.vue?vue&type=script&lang=js&"
export * from "./AddNewWebHostingPackageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc25f5a",
  null
  
)

export default component.exports